import { Injectable } from '@angular/core';
import { CuttingButt } from '../../models/cutting/cutting-butt.model';
import { CuttingMatBaseGroup } from '../../models/cutting/cutting-material-group.model';

export interface MaterialBaseButtResponse {
  materialsDTO: CuttingButt[];
  materialsCount: number;
}

@Injectable()
export abstract class MaterialBaseButtsService {
  public abstract getButtsThickneses(): Promise<number[]>;

  public abstract getButtsFromMatBase(
    groupId: number,
    pageSize: number,
    pageNum: number,
    filterText: string,
    filterByThickness: number,
    panelThickness: number
  ): Promise<MaterialBaseButtResponse>;

  public abstract getButtGroupsFromMatBase(): Promise<CuttingMatBaseGroup[]>;
}
